import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity, Image } from 'react-native';
import Svg, { Path } from 'react-native-svg';

interface Props {
  onCreatePress?: () => void;
}

const AddIcon = () => (
  <Svg width={18} height={18} viewBox="0 0 20 20" fill="none">
    <Path d="M15.8334 10.8337H10.8334V15.8337H9.16675V10.8337H4.16675V9.16699H9.16675V4.16699H10.8334V9.16699H15.8334V10.8337Z" fill="#FFFFFF" />
  </Svg>
);

const StandUpEmptyState: React.FC<Props> = ({ onCreatePress }) => {
  return (
    <View style={styles.outer}> 
      <View style={styles.card}>
        {/* Updated decorative SVG illustration to match the provided design */}
        <View style={styles.illustrationWrapper}> 
          <Svg width={300} height={198} viewBox="0 0 300 198" fill="none">
            <Path d="M183 140.58L134.75 92.5654L99.25 126.72" stroke="#D0D0D0" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
            <Path d="M123.291 104.198H130.525L137.678 110.97L142.327 106.367L146.655 110.652L149.197 108.135" stroke="#D0D0D0" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
            <Path d="M110.5 115.335L99.25 104.94L62.5 141.57" stroke="#D0D0D0" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
            <Path fillRule="evenodd" clipRule="evenodd" d="M108.462 105.949L111.5 115.83L109.183 114.363L105.676 111.511L107.508 105.94C107.594 105.68 107.876 105.537 108.139 105.622C108.294 105.672 108.415 105.794 108.462 105.949Z" fill="#D0D0D0"/>
            <Path fillRule="evenodd" clipRule="evenodd" d="M133.481 147.245C132.113 144.052 128.972 141.819 125.317 141.819C124.31 141.819 123.342 141.988 122.439 142.301C120.726 139.674 117.784 137.942 114.442 137.942C111.246 137.942 108.415 139.527 106.675 141.963C105.98 141.554 105.171 141.32 104.309 141.32C103.554 141.32 102.841 141.5 102.208 141.818C100.499 137.406 96.255 134.281 91.2903 134.281C86.7317 134.281 82.7808 136.915 80.8419 140.762C79.6956 140.217 78.4158 139.913 77.0657 139.913C72.7187 139.913 69.1 143.07 68.3239 147.245H133.481Z" fill="#D0D0D0"/>
            <Path d="M28 146.52H153" stroke="#D0D0D0" strokeWidth="3" strokeLinecap="round"/>
          </Svg>
        </View>


        <Text style={styles.title}>No standup on the board</Text>
        <Text style={styles.subtitle}>Create a standup to add tasks, assign owners, and track progress throughout the shift.</Text>

        <TouchableOpacity style={styles.button} onPress={onCreatePress} activeOpacity={0.8}>
          <AddIcon />
          <Text style={styles.buttonText}>New Stand-up</Text>
        </TouchableOpacity>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  // Make this container full-screen when component is returned directly from the screen
  outer: {
    flex: 1,
    alignSelf: 'stretch',
    // add horizontal padding so the empty-state card has left/right gutters
    paddingHorizontal: 0,
    paddingVertical: 0,
    justifyContent: 'center',
    alignItems: 'stretch',
    backgroundColor: '#F5F9FF', // match page background
  },
  card: {
    // Card fills available width and height
    flex: 1,
    minHeight: 640,
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    // paddingVertical: 40,
    // paddingHorizontal: 48,
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1,
    borderColor: '#F0F4FB',
    // subtle shadow for elevation on native and web
    // shadowColor: '#000',
    shadowOffset: undefined, // Removed shadow offset
    shadowOpacity: undefined, // Removed shadow opacity
    shadowRadius: undefined, // Removed shadow radius
    elevation: 0, // Removed elevation
    marginVertical: 8,
  },
  illustrationWrapper: {
    marginBottom: 24,
  },
  title: {
    fontFamily: 'Primitives/Typography/Font Family/Body',
    fontWeight: '700',
    fontStyle: 'normal', // Corrected to valid value
    fontSize: 16, // Assuming "Font Size/Body" corresponds to 16px
    lineHeight: 24, // Assuming "Line Height/Body" corresponds to 24px
    letterSpacing: 0,
    textAlign: 'center',
    color: '#1C1C1C',
    marginBottom: 10,
  },
  subtitle: {
    textAlign: 'center',
    color: '#6B7280',
    maxWidth: 640,
    fontSize: 14,
    marginBottom: 22,
    lineHeight: 20,
  },
  button: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    backgroundColor: '#004895',
    paddingVertical: 10,
    paddingHorizontal: 18,
    borderRadius: 999,
  },
  buttonText: {
    color: '#FFFFFF',
    fontWeight: '700',
    fontSize: 14,
    // marginLeft: 6,
  },
});

export default StandUpEmptyState;

